import React from 'react';
import { Link } from 'react-router-dom';

const SuccessState = ({ message, subMessage }) => {
  return (
    <div style={{ textAlign: 'center', padding: '16px 0' }}>
      {/* Geometric celebration */}
      <div style={{ position: 'relative', width: '80px', height: '80px', margin: '0 auto 28px' }}>
        {/* Background geometric shapes */}
        <div style={{ position: 'absolute', top: 0, left: 0, width: '60px', height: '60px', border: '2px solid rgba(255, 87, 34, 0.2)', borderRadius: 'var(--radius-sm)', transform: 'rotate(12deg)' }} />
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: '50px', height: '50px', border: '2px solid rgba(255, 87, 34, 0.15)', borderRadius: 'var(--radius-sm)', transform: 'rotate(-8deg)' }} />
        {/* Main circle */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '56px',
          height: '56px',
          background: 'rgba(255, 87, 34, 0.12)',
          border: '2px solid var(--color-accent)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
      </div>

      <div style={{ width: '48px', height: '3px', background: 'var(--color-accent)', margin: '0 auto 20px' }} />

      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '28px', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '12px', lineHeight: 1.2 }}>
        {message || 'Passord oppdatert!'}
      </h2>
      <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--color-muted-foreground)', marginBottom: '36px', lineHeight: 1.6, maxWidth: '320px', margin: '0 auto 36px' }}>
        {subMessage || 'Passordet ditt er oppdatert. Du kan nå logge inn med det nye passordet.'}
      </p>

      <Link
        to="/login"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: '100%',
          background: 'var(--color-accent)',
          border: '2px solid var(--color-accent)',
          borderRadius: 'var(--radius-sm)',
          padding: '14px 24px',
          fontFamily: 'var(--font-heading)',
          fontSize: '16px',
          fontWeight: 700,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: '#FFFFFF',
          textDecoration: 'none',
          transition: 'all 250ms ease-out',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = '#E64A19'; e.currentTarget.style.borderColor = '#E64A19'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'var(--color-accent)'; e.currentTarget.style.borderColor = 'var(--color-accent)'; }}
      >
        Gå til innlogging
      </Link>
    </div>
  );
};

export default SuccessState;
